export const NOT_INITED = 1;
export const INITED = 2;
export const UPDATING = 3;



// WEBPACK FOOTER //
// ./js/constants/RepositoryState.js